import styled from '@emotion/styled'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledIconMute = styled('svg')({
    width: calcRem(20),
    height: calcRem(20),
})
